import { z } from 'zod';

/**
 * Runtime configuration handed to the browser at startup.
 *
 * The Mapbox *browser* token has to reach the client — MapLibre loads styles,
 * sprites, glyphs and vector tiles directly from Mapbox, and no proxy changes
 * that. So rather than baking it into the bundle at build time, the Worker
 * serves it here: one place to set it (`.dev.vars` / `wrangler secret`), and
 * swapping it needs no rebuild. Protect it with URL restrictions in the Mapbox
 * account.
 *
 * The geocoding token is a different credential and never appears here — it
 * stays in the Worker, which is the whole point of the split. All the client
 * learns about it is `searchEnabled`.
 */
export const appConfigSchema = z.object({
  /**
   * The browser token, never the geocoding one. Empty string when no token is
   * configured — the client falls back to a keyless basemap in that case
   * rather than rendering nothing.
   */
  mapboxToken: z.string(),
  /** Whether address search is available (i.e. a geocoding token is set). */
  searchEnabled: z.boolean(),
  environment: z.string(),
});
export type AppConfig = z.infer<typeof appConfigSchema>;
